import React from 'react';

const NoDataIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 160" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.495 89.8457C90.4325 90.2883 90.4002 90.7406 90.4002 91.2004C90.4002 96.5023 94.6983 100.8 100 100.8C105.302 100.8 109.6 96.5023 109.6 91.2004C109.6 90.7406 109.568 90.2883 109.505 89.8457H132.8V111.2C132.8 112.526 131.726 113.6 130.4 113.6H69.6002C68.2747 113.6 67.2002 112.526 67.2002 111.2V89.8457H90.495Z"
        fill="whte"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.4 89.5998C110.4 95.3436 105.744 99.9998 100 99.9998C94.2564 99.9998 89.6002 95.3436 89.6002 89.5998C89.6002 89.4137 89.6051 89.2288 89.6147 89.0451H67.2002L74.8485 66.4309C75.1783 65.456 76.0929 64.7998 77.122 64.7998H122.878C123.908 64.7998 124.822 65.456 125.152 66.4309L132.8 89.0451H110.386C110.395 89.2288 110.4 89.4137 110.4 89.5998Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.878 90.3636C108.878 94.802 104.903 99.2 99.9999 99.2C95.0967 99.2 91.1219 94.802 91.1219 90.3636C91.1219 90.2198 91.126 89.2769 91.1343 89.135H74.3999L80.929 73.2604C81.2105 72.507 81.9912 72 82.8698 72H117.13C118.009 72 118.789 72.507 119.071 73.2604L125.6 89.135H108.866C108.874 89.2769 108.878 90.2198 108.878 90.3636Z"
        fill="#F1F5F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.2002 89.2096V110.4C68.2002 111.173 68.827 111.8 69.6002 111.8H130.4C131.173 111.8 131.8 111.173 131.8 110.4V89.2096L124.205 66.7513C124.012 66.1826 123.479 65.7998 122.878 65.7998H77.122C76.5217 65.7998 75.9882 66.1826 75.7958 66.7513L68.2002 89.2096Z"
        stroke="#6485A7"
        strokeWidth="2.5"
      />
      <path
        d="M78.4 88.7998C81.5493 88.7998 84.9479 88.7998 88.5959 88.7998C90.097 88.7998 90.097 89.8547 90.097 90.3998C90.097 95.7017 94.4939 99.9998 99.9178 99.9998C105.342 99.9998 109.739 95.7017 109.739 90.3998C109.739 89.8547 109.739 88.7998 111.24 88.7998H131.2M72.459 88.7998H74.4H72.459Z"
        stroke="#6485A7"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.08 46.6424L111.2 56.6049M99.2796 43.2002V56.6049V43.2002ZM78.3999 46.6424L87.2796 56.6049L78.3999 46.6424Z"
        stroke="#6485A7"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoDataIcon;
